function T7TableRepetitionsCompareResult({ data }) {

    //console.log("TableDataBootstrap, data, isFetching", data);

    const columns = [
        { header: 'Nro', key: 'index', width: 23, visible: true },
        { header: 'Id', key: 'id', id: 23, visible: true },
         { header: 'Código', key: 'codeCompareResult', width: 23, visible: true },
         { header: 'Nombre', key: 'nameCompareResult', width: 23, visible: true },
        { header: 'Cuenta', key: 'repeticiones', width: 23, visible: true },
         
         
    ];

    return (
        <div>
            <div className="text-start">
                <strong>Tabla: CompareResult, Cantidad de repeticiones por módulo:</strong>
            </div>
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr className=''>
                            {data && data.length > 0 && columns && columns.length > 0 && (
                                columns.map((item, index) => {
                                    return (
                                        <th className=''>{item.header}</th>
                                    )
                                })
                            )}
                        </tr>
                    </thead>
                    <tbody>

                        {/* Start Table Body Columns */}
                        {data && data.length > 0 && (
                            data.map((item, index) => {
                                return (
                                    <tr key={index} className=''>

                                        <td className="list-table-cell-50"> {index+1} </td>
                                        <td className="list-table-cell-100"> {item.id} </td>
                                         <td className="list-table-cell-400"> {item.codeCompareResult} </td>
                                         <td className="list-table-cell-200"> {item.nameCompareResult} </td>
                                        <td className="list-table-cell-100"> {item.repeticiones} </td>
                                    </tr>
                                )
                            })
                        )}
                        {/* End Table Body Columns */}

                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default T7TableRepetitionsCompareResult